import storeDateSelectorResolve from "../../directive/store-date-selector/store-date-selector.resolve";

export default function routes($stateProvider) {
	$stateProvider.state("summaryRankingPage", {
		url: "/summaryRanking/:stores?startDate&endDate",
		template: require("./summaryRanking.html"),
		resolve: {
			...storeDateSelectorResolve,
			brand: [
				"Brand",
				function(Brand) {
					return Brand.get();
				}
			],
			storesInfoLoader: [
				"SummaryRanking",
				"selectedStore",
				"endDate",
				"startDate",
				function(SummaryRanking, selectedStore, endDate, startDate) {
					return _ =>
						SummaryRanking.get({
							stores: JSON.stringify(selectedStore.storeIds),
							startDate,
							endDate
						});
				}
			],
			storesInfo: [
				"storesInfoLoader",
				function(storesInfoLoader) {
					return storesInfoLoader();
				}
			]
		},
		controller: "SummaryRankingController",
		controllerAs: "summaryRanking"
	});
}

routes.$inject = ["$stateProvider"];



// WEBPACK FOOTER //
// ./src/page/summaryRanking/summaryRanking.routes.js